/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { LuAlertTriangle } from 'react-icons/lu';

import { formatCurrency, formatPercent, pluralTitulos } from '../utils/format';
import {
   CoverageAction,
   CoverageBody,
   CoverageStrip,
   CoverageText,
   CoverageTitle,
} from '../styles';

// ---------------------------------------------------------------------------
// [C] Banner de cobertura de origem.
//
// Só aparece quando o operador filtrou por origem E o período alcança a carga
// histórica — o recorte em que a quebra por departamento é enganosa, porque
// grande parte dos títulos entrou sem origem.
//
// Os números, quando existem, vêm do `sem_classificacao` do breakdown (dado
// real do recorte), NUNCA hardcoded. Mas eles podem não vir: filtrar por
// `origin_id` exclui justamente os títulos sem origem, então o payload
// filtrado costuma trazer `sem_classificacao: null`. Nesse caso o aviso é
// qualitativo — inventar a contagem seria pior que omiti-la.
// ---------------------------------------------------------------------------

export default function CoverageBanner({
   unclassified,
   coverageStart,
   onApplyCoverageStart,
}) {
   const hasNumbers = Boolean(unclassified?.titulos);

   return (
      <CoverageStrip role="status">
         <LuAlertTriangle size={20} strokeWidth={1.8} aria-hidden="true" />
         <CoverageBody>
            <CoverageTitle>
               Cobertura de origem incompleta no período selecionado
            </CoverageTitle>
            <CoverageText>
               {hasNumbers ? (
                  <>
                     {pluralTitulos(unclassified.titulos)}
                     {unclassified.share_pct !== null &&
                     unclassified.share_pct !== undefined
                        ? ` (${formatPercent(unclassified.share_pct, 1)} do valor)`
                        : ''}
                     {unclassified.emitido
                        ? ` — ${formatCurrency(unclassified.emitido)}`
                        : ''}{' '}
                     vieram da carga histórica sem origem.{' '}
                  </>
               ) : (
                  <>
                     Boa parte dos títulos anteriores a {coverageStart} veio da
                     carga histórica do ASAAS, que não trouxe o departamento
                     gerador.{' '}
                  </>
               )}
               A quebra por departamento só é confiável a partir de{' '}
               {coverageStart}.
            </CoverageText>
         </CoverageBody>
         <CoverageAction type="button" onClick={onApplyCoverageStart}>
            Começar em mar/2026
         </CoverageAction>
      </CoverageStrip>
   );
}

CoverageBanner.propTypes = {
   unclassified: PropTypes.shape({
      titulos: PropTypes.number,
      emitido: PropTypes.number,
      share_pct: PropTypes.number,
   }),
   coverageStart: PropTypes.string.isRequired,
   onApplyCoverageStart: PropTypes.func.isRequired,
};
